import axios from "utils/httpClient";
import React, { useEffect, useState, Fragment } from "react";
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '_services';
import { authHeader } from '_helpers';
import Async, { useAsync } from 'react-select/async';
import { Collapse, Modal, ModalBody } from "reactstrap";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

// reactstrap components
import {
    Button,
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane,
    Container,
    Row,
    Col,
    Input,
    Label
} from "reactstrap";


// core components
import DefaultFooter from "components/Footers/DefaultFooter.js";

const ICD10 = (props) => {
    var moment = require('moment');
    require('moment/locale/th');
    const serviceUnitKey = (props.match.params.serviceUnitKey !== undefined) ? props.match.params.serviceUnitKey : null;
    const startDate = (props.match.params.startDate !== undefined) ? props.match.params.startDate : null;
    const endDate = (props.match.params.endDate !== undefined) ? props.match.params.endDate : null;
    //const json = (props.match.params.json !== undefined) ? props.match.params.json : null;


    const length = 12;
    const [Data, SetData] = useState([]);
    const [clinicVisitKey, SetClinicVisitKey] = useState("");
    const [state, setState] = useState(0);
    const [ServiceUnitKey, setServiceUnitKey] = useState(0);
    const [StartDate, setStartDate] = useState("");
    const [EndDate, setEndDate] = useState("");
    const [CCNote, setCCNote] = useState([]);
    const [icd10, setICD10] = useState([]);
    const [diagnosis, setDiagnosis] = useState([]);
    const [PDX, setPDX] = useState([]);
    const [modal, setModal] = useState(false);
    const [errMsg, setErrMsg] = useState([]);
    const [modalError, setModalError] = useState(false);
    //const [isJSON, setisJSON] = useState("");
    //const [CCNote, setCCNote] = useState(Array.from({ length }, () => 12));

    const loadDiagnosis = async () => {
        return [
            { value: 0, label: "Doctor Dx" },
            { value: 1, label: "Primary Dx" },
            { value: 2, label: "Comorbidity" },
            { value: 3, label: "Complication" },
            { value: 4, label: "Others" }
        ];
    };

    const loadPDX = async (index2) => {
      
        // กรองเฉพาะแถวอื่นที่ diagnosis = 1 ด้วย
        const options = Object.entries(icd10)
          .filter(([key, val]) => {
            const idx = parseInt(key);
            return (
              idx !== index2 &&                            
              diagnosis[idx]?.value === 1 &&             
              val                                          
            );
          })
          .map(([_, item]) => ({
            value: item.value,
            label: `${item.label}`
          }));
      
        return options;
      };

    const handleInput = (selected, index) => {
        setICD10(prev => ({
          ...prev,
          [index]: selected
        }));
      };

    const handleInput2 = (selected, index) => {
        setDiagnosis(prev => ({
          ...prev,
          [index]: selected
        }));
    };
    
    const handleInput3 = (selected, index2) => {
        setPDX(prev => ({ ...prev, [index2]: selected }));
    };

    useEffect(() => {
        Object.keys(diagnosis).forEach(key => {
          const index = parseInt(key);
          if (diagnosis[index]?.value === 1) {
            setPDX(prev => ({
              ...prev,
              [index]: null,
            }));
          }
        });
      }, [diagnosis]);

    const handleInputOld = (inputEv, index, clinicVisitKey) => {
        var value = [];
        var values = []
        if(inputEv.length > 0){
            inputEv.forEach(a => {
                value.push(a)
                values.push(a.value)
            });
        }
        //console.log(value);
        setICD10((state) => state.map((val, i) => (i !== index ? val : value)));


        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
            },
            data: {
                "labels": values,
            }
        };
        axios('/api/v1/icd10/'+ clinicVisitKey + '/' + index, requestOptions)
        .then(response => response.data)
        .then(
            (result) => {
                //console.log("Test");
                //console.log(result);
            },
            (error) => {
                alert('update error' + error);
            }
        )
    };
    const handleConfirm = (CNDX, clinicVisitKey) => {
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
            },
            data: CNDX
        };
        axios('/api/v1/icd10/'+ clinicVisitKey, requestOptions)
        .then(response => response.data)
        .then(
            (result) => {
                console.log('Success:', result);
                setModal(true);
            },
            (error) => {
                alert(error);
            }
        )
    };

    
    const handleList = (data) => {
        data.forEach(function (value) {
            CCNote.push(value.CCNote == null ? "" : value.CCNote)
            //console.log(CCNote)
        }); 
    };

    useEffect(() => {

        axios('/api/v1/icd10/' + serviceUnitKey + '/' + startDate + '/' + endDate, {
            method: 'GET',
            headers: authHeader()
        })
        .then(response => response.data)
        .then(
            (result) => {
                SetData(result.data);
                handleList(result.data)
            },
            (error) => {
                //alert(error);
            }
        );
        
        if (serviceUnitKey != null) {
            setServiceUnitKey(serviceUnitKey);
        }    
        if (startDate != null) {
            setStartDate(startDate);
        }    
        if (endDate != null) {
            setEndDate(endDate);
        }    
        // if (json != null) {
        //     setisJSON(json);
        // }    
            
    }, []);

    useEffect(() => {
        // console.log(icd10);
        // console.log(clinicVisitKey);
    }, [icd10]);

    
    useEffect(() => {

        axios('/api/v1/icd10/' + ServiceUnitKey + '/' + StartDate + '/' + EndDate, {
            method: 'GET',
            headers: authHeader()
        })
            .then(response => response.data)
            .then(
                (result) => {
                    SetData(result.data);
                },
                (error) => {
                    //alert(error);
                }
            );
            
    }, [ServiceUnitKey]);

    function handleClick(row) {
        //SetClinicVisitKey(row);
    }

    const handleAddCNDX = (rowIndex) => {
        const updatedData = [...Data];
        const row = updatedData[rowIndex];
      
        const newCNDX = {
          icd10Code: "",
          icd10ENName: "",
          dxTypeKey: 0, 
        };
      
        // ถ้า row.CNDX ยังไม่มี ให้สร้าง array ใหม่
        if (!Array.isArray(row.CNDX)) {
          row.CNDX = [newCNDX];
        } else {
          row.CNDX.push(newCNDX);
        }
      
        SetData(updatedData);      // อัพเดต state หลัก
        setState((prev) => prev + 1); // trigger rerender
      };
      

    const loadOptions = (inputValue, callback) => {
        if(inputValue !== ''){
            axios("/api/v1/icd10?Keyword=" + inputValue)
            .then(response => response.data)
            .then(data => {
                const options = data.data;
                callback(options)}, (error) => { console.log(error) })
        } else {
            const options = [];
            callback(options)
        }
    };

    const กiagnosisOptions = (inputValue, callback) => {
        if(inputValue !== ''){
            axios("/api/v1/icd10?Keyword=" + inputValue)
            .then(response => response.data)
            .then(data => {
                const options = data.data;
                callback(options)}, (error) => { console.log(error) })
        } else {
            const options = [];
            callback(options)
        }
    };

    const handleClick2 = (index) => {
        const updatedState = Data[index];
    
        if (updatedState.other) {
          delete updatedState.other;
          setState((pre) => {

            return pre + 1;
          });
        } else {
          updatedState.other = {
            description: " " //or data from api
          };
          setState((pre) => {
            return pre + 1;
          });
        }
      };

    const currentUser = authenticationService.currentUserValue;
    if (!currentUser) {
        return <Redirect to={{ pathname: '/login-page', /*state: { from: props.location }*/ }} />
    } 
    
    return (
        // <Container>
        //     <Row>
        //         <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{textAlign: 'center'}}>
        //             <h3 className="p-3 text-center">React - Display a list of items</h3>
        //             <table className="table table-striped table-bordered">
        //                 <thead>
        //                     <tr>
        //                         <th>วันที่</th>
        //                     </tr>
        //                 </thead>
        //                 <tbody>
        //                 {Data && Data.map(data =>
        //                     <tr key={data.clinicVisitKey} onClick={() => handleClick(data.clinicVisitKey)}> 
        //                         <td>{data.docDT}</td>
        //                     </tr>
        //                     )}
        //                 </tbody>
        //             </table>
        //         </Col>
        //     </Row>
        // </Container>

        <div className="wrapper">
            <div className="section" style={{ padding: 30 }}>
                <Container>
                    <h3 className="title" style={{
                        fontSize: '1.2em', backgroundColor: '#f2f2f2', 
                        textAlign: 'center'
                    }}>ICD10</h3>
            
                 </Container>
            </div>

            {/* {Data && Data.map(data =>
            <Container>
            <Row key={data.clinicVisitKey} style={{ fontSize: '0.85em', padding: '10px 10px', borderBottom: '1px solid #dddddd' }}>
                <Col md="12" xs="12">
                    {data.docDT}
                </Col>
            </Row>
            </Container>
             )} */}
          
          {Data && Data.map((row, index) => (
            <Fragment key={`${index}${row.ClinicVisitKey}`}>
            <Container>
            <Row key={row.ClinicVisitKey} style={ row.other ? { fontSize: '0.85em', padding: '10px 10px',
                    cursor: "pointer", textAlign: "center", fontWeight: 'bold', backgroundColor: '#f2f2f2'} 
                    : { fontSize: '0.85em', padding: '10px 10px', borderBottom: '1px solid #dddddd',
                    cursor: "pointer", textAlign: "center", fontWeight: 'bold'}} onClick={() => handleClick2(index)}>
                 <Col md="6" xs="12">
                    {row.Patient} {moment(row.RecordDT).format('DD MMM BB, HH:mm น.')} 
                </Col>
                <Col md="6" xs="12">
                    {row.ServiceUnit}
                </Col>
            </Row>
            </Container>
              {row.other ? (
                <Container>
                <Row style={{fontSize: '0.85em', fontWeight: 'bold', textAlign: "center", paddingTop: "20px"}}>
                    <Col md="4" xs="12">
                        {row.Cid}
                    </Col>
                    <Col md="4" xs="12">
                       
                    </Col>
                    <Col md="4" xs="12">
                        {row.Patient}
                    </Col>
                </Row>
                <Row style={{fontSize: '0.85em', fontWeight: 'bold', textAlign: "center"}}>
                    <Col md="4" xs="12">
                        {row.Gender}
                    </Col>
                    <Col md="4" xs="12">
                        {row.Age}
                    </Col>
                    <Col md="4" xs="12">
                        {row.HN}
                    </Col>
                </Row>
                <Row style={{fontSize: '0.85em', textAlign: "center"}}>
                    <Col md="4" xs="12">
                        วันที่ {moment(row.RecordDT).format('DD MMM BB, HH:mm น.')}
                    </Col>
                    <Col md="4" xs="12">
                        {row.ServiceUnit}
                    </Col>
                    <Col md="4" xs="12">
                        {row.MC}
                    </Col>
                </Row>
                <Row style={{fontSize: '0.85em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.VS}
                    </Col>
                </Row>
                 <Row style={{fontSize: '0.85em', textAlign: "left", paddingTop: "20px"}}>
                    <Col md="6" xs="12">
                        น้ำหนัก {row.Weight}  กก. ส่วนสูง {row.Height}  ซม. รอบเอว {row.WaistLength} ซม. BMI {row.Bmi} {row.BmiText}
                    </Col>
                    <Col md="6" xs="12">
                        
                    </Col>
                </Row>
                <Row style={{fontSize: '0.85em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.PI}
                    </Col>
                </Row>
                <Row style={{fontSize: '0.85em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.PE}
                    </Col>
                </Row>
                <Row style={{fontSize: '0.85em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.DX}
                    </Col>
                </Row>              
                <Row style={{fontSize: '0.85em', textAlign: "left", paddingTop: "20px", color: "#F14141"}}>
                    <Col>
                        {row.DX2}
                    </Col>
                </Row>
                {/* <Row className="justify-content-center" style={{fontSize: '0.85em', textAlign: "center", paddingTop: "20px", paddingBottom: "20px"}}>
                    <Col md="12" xs="12">
                    {row.DX2.split(", ").map((item2, index2) => {
                        const [key, value] = item2.split(":");
                        return (
                            <Container>
                                <Row style={{borderBottom: '1px solid #dddddd', paddingBottom: "10px", paddingTop: "10px"}}>
                                    <Col Col md="3" xs="6">
                                        <div key={index}>
                                            <strong>{key}:</strong> {value}
                                        </div>
                                    </Col>
                                    <Col md="3" xs="6">
                                        <Async
                                            placeholder="ICD10Code"
                                            //isMulti
                                            cacheOptions
                                            defaultOptions
                                            loadOptions={loadOptions}
                                            onChange={(e) => handleInput(e, index2)} value={icd10[index2] || null} 
                                            //onChange={(e) => handleInput(e, index2, row.ClinicVisitKey)} value={icd10[index2]}
                                        />
                                    </Col>
                                    <Col md="3" xs="6">
                                        <Async
                                            placeholder="การวินิจฉัย"
                                            //isMulti
                                            cacheOptions
                                            defaultOptions
                                            loadOptions={loadDiagnosis}
                                            onChange={(e) => handleInput2(e, index2)} value={diagnosis[index2] || null} 
                                            //onChange={(e) => handleInput(e, index2, row.ClinicVisitKey)} value={icd10[index2]}
                                        />
                                    </Col>
                                    <Col md="3" xs="6">
                                        <Async
                                            placeholder="PDX"
                                            //isMulti
                                            cacheOptions
                                            defaultOptions
                                            loadOptions={() => loadPDX(index2)} // ⬅ ส่ง index2 เข้าไป
                                            onChange={(e) => handleInput3(e, index2)}
                                            value={PDX[index2] || null}
                                            isDisabled={diagnosis[index2]?.value === 1}
                                        />
                                    </Col>
                                </Row>
                            </Container>
                        );
                    })}
                    </Col>                  
                </Row>     */}
                <Row className="justify-content-center" style={{fontSize: '0.85em', textAlign: "center", paddingTop: "20px", paddingBottom: "20px"}}>
                    <Col md="12" xs="12">
                    {row.CNDX.map((item2, index2) => {
                          const defaultICD10 = item2.icd10Code
                          ? { value: item2.icd10Code, label: item2.icd10ENName || item2.icd10Code }
                          : null;

                          if (!icd10[index2] && defaultICD10) {
                            handleInput(defaultICD10, index2);
                          }
                       
                          const diagnosisOptions = [
                            { value: 0, label: "Doctor Dx" },
                            { value: 1, label: "Primary Dx" },
                            { value: 2, label: "Comorbidity" },
                            { value: 3, label: "Complication" },
                            { value: 4, label: "Others" }
                          ];

                          const defaultDiagnosis = diagnosisOptions.find(opt => opt.value === item2.dxTypeKey);
                          
                          if (!diagnosis[index2] && defaultDiagnosis) {
                            handleInput2(defaultDiagnosis, index2);
                          }

                        return (
                            <Container key={index2}>
                                <Row style={{ borderBottom: '1px solid #dddddd', paddingBottom: "10px", paddingTop: "10px" }}>
                                    <Col md="3" xs="6">
                                        {console.log(item2)}
                                        {item2.dxTypeKey === 0 ? "Doctor Dx"  + " : ": 
                                        item2.dxTypeKey === 1 ? "Primary Dx"  + " : ":
                                        item2.dxTypeKey === 2 ? "Comorbidity"  + " : ":
                                        item2.dxTypeKey === 3 ? "Complication"  + " : ":
                                        "Others" + " : "}{item2.icd10ENName}
                                    </Col>
                                    <Col md="3" xs="6">
                                        <Async
                                            placeholder="ICD10Code"
                                            //isMulti
                                            cacheOptions
                                            defaultOptions
                                            loadOptions={loadOptions}
                                            onChange={(e) => {handleInput(e, index2);
                                                row.CNDX[index2].icd10Code = e?.value || null;
                                                row.CNDX[index2].icd10ENName = e?.label || null;}
                                            } 
                                            value={icd10[index2] || defaultICD10}
                                            //onChange={(e) => handleInput(e, index2, row.ClinicVisitKey)} value={icd10[index2]}
                                        />
                                    </Col>
                                    <Col md="3" xs="6">
                                        <Async
                                            placeholder="การวินิจฉัย"
                                            //isMulti
                                            cacheOptions
                                            defaultOptions
                                            loadOptions={loadDiagnosis}
                                            onChange={(e) => handleInput2(e, index2)} 
                                            value={diagnosis[index2] || defaultDiagnosis || null}
                                            //onChange={(e) => handleInput(e, index2, row.ClinicVisitKey)} value={icd10[index2]}
                                        />
                                    </Col>
                                    <Col md="3" xs="6">
                                        <Async
                                            placeholder="PDX"
                                            //isMulti
                                            cacheOptions
                                            defaultOptions
                                            loadOptions={() => loadPDX(index2)} // ⬅ ส่ง index2 เข้าไป
                                            onChange={(e) => handleInput3(e, index2)}
                                            value={PDX[index2] || null}
                                            isDisabled={diagnosis[index2]?.value === 1}
                                        />
                                    </Col>
                                </Row>
                            </Container>
                            );
                        })}

                        {row.CNDX.length === 0 && (
                        <div style={{ textAlign: "center", marginBottom: "20px" }}>
                        <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => handleAddCNDX(index)}
                        >
                            + เพิ่มการวินิจฉัย
                        </button>
                        </div>
                        )}
                    </Col>                  
                </Row>   
                <Row style={{borderBottom: '1px solid #dddddd', paddingBottom: "10px", fontSize: '0.85em', justifyContent: 'center'}}>
                   <Button
                        color="primary"
                        type="button"
                        onClick={(e) => {
                            var cntErr = 0;
                            var errMsg = [];

                            const allHaveICD10 = row.CNDX.every(item => item.icd10Code && item.icd10Code.trim() !== '');
                            if(!allHaveICD10){
                                cntErr += 1;
                                errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ ICD10 ให้ครบทุกรายการ"}</li>);
                            }
                            
                            if (cntErr > 0) {
                                setErrMsg(errMsg);
                                setModalError(true);
                            } else {
                                handleConfirm(row.CNDX, row.ClinicVisitKey)
                            }}
                        }
                    >
                    บันทึก
                    </Button>
                </Row>  
                <Row style={{fontSize: '0.85em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.Lab}
                    </Col>
                </Row>
                <Row style={{fontSize: '0.85em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.Discharge}
                    </Col>
                </Row>
                <Row style={{fontSize: '0.85em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.History}
                    </Col>
                </Row>
                <Row style={{fontSize: '0.85em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.Appoint}
                    </Col>
                </Row>
                <Row style={{fontSize: '0.85em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.NursingCare}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {row.Med}
                    </Col>
                </Row>  
                <Row className="justify-content-center" style={{fontSize: '0.85em', textAlign: "center", borderBottom: '1px solid #dddddd', paddingTop: "20px", paddingBottom: "20px"}}>
                </Row>                    
                </Container>
              ) : null}
            </Fragment>
          ))}
        <DefaultFooter />
           <Card>
                <CardHeader>
                </CardHeader>
                <CardBody>
                     <Modal toggle={() => setModal(false)} isOpen={modal}>
                        <div className="modal-header justify-content-center">
                            <div>
                            <i
                                className="fa fa-check-circle"
                                style={{ color: "green", fontSize: "2em" }}
                            ></i>
                            </div>
                        </div>
                            <ModalBody>
                                <p
                                    style={{
                                        textAlign: "center"
                                    }}
                                >
                                   {"บันทึกสำเร็จ"}
                                </p>
                                <p> </p>
                            </ModalBody>
                            <div className="modal-footer justify-content-center">
                            <Button
                                color="primary"
                                type="button"
                                onClick={() => setModal(false)}
                            >
                                <h4>ยืนยัน</h4>
                            </Button>
                            </div>
                        </Modal>
                        {/* Error */}
                        <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                            <div className="modal-header justify-content-center">
                                <div>
                                    <i
                                        className="fa fa-times"
                                        style={{ color: "red", fontSize: "2em" }}
                                    ></i>
                                </div>
                            </div>
                            <ModalBody>
                                <p>ไม่สามารถบันทึกข้อมูลได้</p>
                                <div>{errMsg}</div>
                            </ModalBody>
                            <div className="modal-footer justify-content-center">
                            <Button
                                color="primary"
                                type="button"
                                onClick={() => setModalError(false)}
                            >
                            <h4>ตกลง</h4>
                            </Button>
                            </div>
                        </Modal>
                </CardBody>
                <CardFooter>

                </CardFooter>
            </Card>
        </div>
    );
}

export default ICD10; 
